import { render, staticRenderFns } from "./InforNewCampSms.vue?vue&type=template&id=474d0220&scoped=true&"
import script from "./InforNewCampSms.vue?vue&type=script&lang=js&"
export * from "./InforNewCampSms.vue?vue&type=script&lang=js&"
import style0 from "./InforNewCampSms.vue?vue&type=style&index=0&id=474d0220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474d0220",
  null
  
)

export default component.exports